import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";
const initialStateValue = {
  showCheckReturnList: false,
  saveBtnDisable: false,
  filterData: {
    branchValue: null,
    branchTouch: false,
    voucherDate: "",
    voucherDateTouch: false,
    voucherDateDisabled: false,
  },
  gridRows: [],
  gridPaginationData: {
    lastActivePage: 0,
  },
  data: {
    id: "",
    addRecord: false,
    deleteCheckValue: false,
    chequeNum: "",
    chequeDate: null,
    applicationNum: "",
    chequeAmt: "0",
    returnReason: "",
    returnReasonCode: "",
    charges: "0",
    voucherNum: "",
    voucherDate: null,
    branch: "",
    branchCode: "",
    charset: "",
    draweeBank: "",
    draweeBankBranch: "",
    customerName: "",
    chequeType: "",
    returnReasonArray: [],
    returnReasonError: false,
    chargesError: false,
    chequeNumError: false,
    chequeNumRecords: [],
    voucherNumArray: [],
    voucherNumTouch: false,
  },
};
const ChequeReturnReducer = createSlice({
  name: "chequeReturn",
  initialState: initialStateValue,
  reducers: {
    updateSaveBtnDisable(state, action) {
      state.saveBtnDisable = action.payload;
    },
    updateVoucherDateDisabled(state, action) {
      state.filterData.voucherDateDisabled = action.payload;
    },
    updateShowCheckReturnList(state, action) {
      state.showCheckReturnList = action.payload;
    },
    updateBranchTouchHandler(state, action) {
      state.filterData.branchTouch = action.payload;
    },
    updateVoucherDateTouchHandler(state, action) {
      state.filterData.voucherDateTouch = action.payload;
    },

    updateReturnReasonTouchHandler(state, action) {
      state.data.returnReasonError = action.payload;
    },

    updateChargesTouchHandler(state, action) {
      state.data.chargesError = action.payload;
    },

    updateChequeNumErrorHandler(state, action) {
      state.data.chequeNumError = action.payload;
    },

    updateGridRows(state, action) {
      state.gridRows = action.payload;
    },

    updateGridPaginationData(state, action) {
      state.gridPaginationData = action.payload;
    },
    resetGridRows(state, action) {
      state.gridRows = [];
      state.gridPaginationData.lastActivePage = 0;
    },
    resetFilterValues(state, action) {
      state.filterData.branchValue = null;
      state.filterData.voucherDate = null;
      state.filterData.voucherDateDisabled = false;
    },
    updateBranchValue(state, action) {
      state.filterData.branchValue = action.payload;
    },
    updateVoucherDateValue(state, action) {
      state.filterData.voucherDate =
        action.payload !== null &&
        action.payload !== undefined &&
        action.payload !== ""
          ? new Date(dayjs(action.payload).format("MM/DD/YYYY"))
          : null;
    },

    updateChequeAmt(state, action) {
      state.data.chequeAmt = action.payload;
    },
    updateVoucherNumArray(state, action) {
      state.data.voucherNumArray = action.payload;
    },
    updateVoucherNumTouchHandler(state, action) {
      state.data.voucherNumTouch = action.payload;
    },
    updateVoucherNum(state, action) {
      state.data.voucherNum = action.payload;
    },
    updateReturnReasonArray(state, action) {
      state.data.returnReasonArray = action.payload;
    },

    updateChequeNumber(state, action) {
      state.data.chequeNum = action.payload;
    },

    updateReturnReason(state, action) {
      state.data.returnReason = action.payload;
    },

    updateReturnReasonCode(state, action) {
      state.data.returnReasonCode = action.payload;
    },

    updateCharges(state, action) {
      state.data.charges = action.payload;
    },

    updateChequeNumRecords(state, action) {
      state.data.chequeNumRecords = action.payload;
    },

    updateValues(state, action) {
      state.data.id = action.payload.id;
      state.data.addRecord = action.payload.addRecord;
      state.data.deleteCheckValue = action.payload.deleteCheckValue;
      state.data.chequeNum = action.payload.chequeNum;
      state.data.chequeDate = action.payload.chequeDate;
      state.data.applicationNum = action.payload.applicationNum;
      state.data.chequeAmt = action.payload.chequeAmt;
      state.data.returnReason = action.payload.returnReason;
      state.data.returnReasonCode = action.payload.returnReasonCode;
      state.data.charges = action.payload.charges;
      state.data.voucherNum = action.payload.voucherNum;
      state.data.voucherDate = action.payload.voucherDate;
      state.data.branch = action.payload.branch;
      state.data.branchCode = action.payload.branchCode;
      state.data.charset = action.payload.charset;
      state.data.draweeBank = action.payload.draweeBank;
      state.data.draweeBankBranch = action.payload.draweeBankBranch;
      state.data.customerName = action.payload.customerName;
      state.data.chequeType = action.payload.chequeType;
      state.data.returnReasonArray = action.payload.returnReasonArray;
      state.data.voucherNumArray = action.payload.voucherNumArray;
    },

    resetValues(state, action) {
      state.data.id = "";
      state.data.addRecord = false;
      state.data.deleteCheckValue = false;
      if (action.payload) {
        // when payload is true means it's reset all for cheque num change or delete.
        // when payload was false reset is called for voucher num -> null
        state.data.chequeNum = "";
        state.data.voucherNum = "";
        state.data.voucherNumArray = [];
        state.data.voucherNumTouch = false;
      } else {
        state.data.voucherNum = "";
        state.data.voucherNumTouch = false;
      }
      state.data.chequeDate = null;
      state.data.applicationNum = "";
      state.data.chequeAmt = "0";
      state.data.returnReason = "";
      state.data.returnReasonCode = "";
      state.data.charges = "0";
      state.data.voucherDate = null;
      state.data.branch = "";
      state.data.branchCode = "";
      state.data.charset = "";
      state.data.draweeBank = "";
      state.data.draweeBankBranch = "";
      state.data.customerName = "";
      state.data.chequeType = "";
      state.data.chequeNumRecords = [];
    },
  },
});
export const ChequeReturnReducerAction = ChequeReturnReducer.actions;
export default ChequeReturnReducer.reducer;
